import { createStore } from 'satcheljs';
import SmimeOptionsViewState from './schema/SmimeOptionsViewState';

export default createStore<SmimeOptionsViewState>('SmimeOptionStore', {
    isSmimeEncrypt: null,
    isSmimeSign: null,
    isManuallyPickCertificate: null,
    signingCertificateId: null,
    signingCertificateSubject: null,
});
